import { IntegrationEntitySyncTag } from "components";
import { DefaultHeaderCell } from "components/table-v2/header-cells";
import { DefaultRowCell } from "components/table-v2/row-cells";
import { ITableV2Column } from "components/table-v2/table-v2";
import { TAutomatedReferralSyncOfficeExtendedData } from "types/automated-referrals.type";
import { AutomatedReferralOfficeSyncInput } from "./AutomatedReferralOfficeSyncInput";

export const syncAutomatedReferralOfficeTableColumnDef = (
  updateSyncPair: (syncPair: TAutomatedReferralSyncOfficeExtendedData) => void
): ITableV2Column<TAutomatedReferralSyncOfficeExtendedData>[] => {
  return [
    {
      accessor: "officeName",
      Header: <DefaultHeaderCell>LeadPro office</DefaultHeaderCell>,
      Cell: ({ row }) => <DefaultRowCell>{row.officeName}</DefaultRowCell>,
    },
    {
      accessor: "membersHubOfficeId",
      excludeFromGlobalFilter: true,
      disableSortBy: true,
      Header: <DefaultHeaderCell>Referrals Office</DefaultHeaderCell>,
      Cell: ({ row }) => (
        <DefaultRowCell>
          <AutomatedReferralOfficeSyncInput
            onChange={updateSyncPair}
            record={row}
            placeholder={`Enter referrals office ID`}
          />
        </DefaultRowCell>
      ),
    },
    {
      accessor: "syncStatus",
      excludeFromGlobalFilter: true,
      Header: <DefaultHeaderCell>Status</DefaultHeaderCell>,
      Cell: ({ row }) => (
        <DefaultRowCell>
          <IntegrationEntitySyncTag syncStatus={row.syncStatus} />
        </DefaultRowCell>
      ),
    },
  ];
};
